// src/components/AsignarIngreso.js

import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';

function AsignarIngreso() {
    const [ingresoID, setIngresoID] = useState('');
    const [cuenta, setCuenta] = useState('');
    const [mensaje, setMensaje] = useState(null);

    const handleAsignarIngreso = async (e) => {
        e.preventDefault();

        const asignarIngresoData = {
            ingresoID,
            cuenta,
        };

        try {
            const response = await fetch('http://tu-servidor/api/asignar-ingreso', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(asignarIngresoData),
            });

            const data = await response.json();

            if (response.ok) {
                setMensaje({ type: 'success', text: 'Ingreso asignado exitosamente.' });
                setIngresoID('');
                setCuenta('');
            } else {
                setMensaje({ type: 'error', text: data.message || 'Error al asignar el ingreso.' });
            }
        } catch (error) {
            setMensaje({ type: 'error', text: 'Error de conexión con el servidor.' });
        }
    };

    return (
        <div className="container mt-5">
            <h2>Asignar Ingreso</h2>
            {mensaje && <Alert variant={mensaje.type === 'error' ? 'danger' : 'success'}>{mensaje.text}</Alert>}
            <Form onSubmit={handleAsignarIngreso}>
                <Form.Group controlId="formIngresoID">
                    <Form.Label>ID del Ingreso</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="ID del ingreso"
                        value={ingresoID}
                        onChange={(e) => setIngresoID(e.target.value)}
                        required
                    />
                </Form.Group>

                <Form.Group controlId="formCuenta">
                    <Form.Label>Cuenta Asignada</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Cuenta Asignada"
                        value={cuenta}
                        onChange={(e) => setCuenta(e.target.value)}
                        required
                    />
                </Form.Group>

                <Button variant="primary" type="submit" className="mt-3">
                    Asignar Ingreso
                </Button>
            </Form>
        </div>
    );
}

export default AsignarIngreso;
